import { jwtDecode } from "jwt-decode";

type JwtPayload = {
  unique_name?: string;
  Fullname?: string;
  [key: string]: unknown;
};

export function useBlockedUser(token?: string): boolean {
  const blockedUsers = ["burger"];

  if (!token || !blockedUsers) return false;

  try {
    const decoded = jwtDecode<JwtPayload>(token);
    const username = decoded?.unique_name || decoded?.Fullname;

    return blockedUsers.includes(username?.toLowerCase() || "");
  } catch {
    return false;
  }
}
